module.exports = __webpack_public_path__ + "img/eliminar cuota.5c057a2f.png";